<!--多个分销商时选择登陆-->
<template>
  <q-dialog ref="dialogRef" class="base-dialog" v-model="isShow" :persistent="true">
    <q-card class="q-dialog-plugin card-vue default">
      <q-card-actions>
        <span class="text-h6">请选择分销商</span>
      </q-card-actions>
      <q-separator></q-separator>
      <q-form @submit="onSubmit">
        <q-card-section class="q-pa-sm">
          <div class="row">
            <div class="row items-center q-mb-sm justify-end item-vue">
              <div class="q-mr-sm label-vue">
                <span class="text-pink q-mr-xs">*</span>分销商
              </div>
              <q-select class="content-vue" dense outlined transition-show="jump-up" options-dense emit-value map-options
                        transition-hide="jump-up" v-model=node.value :options=options :error="node.isError" :error-message="node.msg">
              </q-select>
            </div>
          </div>
        </q-card-section>
        <q-separator></q-separator>
        <!-- 按钮示例 -->
        <q-card-actions align="right">
          <q-btn label="取消" size='9px' @click="close" />
          <q-btn color="primary" size='9px' label="确定" type="submit" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import {ref,toRef} from "vue";
import {isEmpty} from "../tools/utils";
export default {
  props: ["options"],
  setup(props,context) {
    let isShow = ref(false);
    let node = ref({
      value:'',
      isError:false,
      msg:''
    })
    function onOKClick() {
      node.value.isError = false;
      node.value.msg = '';
      if(isEmpty(node.value.value)){
        node.value.isError = true;
        node.value.msg = '分销商不能为空！';
      }else{
        context.emit('clickOk',node.value.value);
      }
    }
    function onSubmit() {
      onOKClick();
    }
    function open(){
      isShow.value = true;
    }
    function close(){
      isShow.value = false;
      context.emit('close')
    }
    return {
      open,
      close,
      isShow,
      node,
      onOKClick,
      onSubmit,
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep.q-field--auto-height .q-field__native{
  min-height: 0px !important;
}
.base-dialog{
  .card-vue {
    .item-vue {
      width: 315px;
      height: 45px;
      align-items: flex-start;
      .label-vue {
        transform: none !important;
      }
      .content-vue {
        width: 200px;
      }
    }
    .radio-vue{
      width: 200px;
      transform: translateY(-25%);
    }
  }
  //宽度可以放一列
  .default {
    min-width: 500px;
    .item-vue {
      width: 300px;
      .label-vue {
        transform: none !important;
      }
      .content-vue {
        width: 200px;
      }
    }
  }
  .filter-select{
    ::v-deep .q-field__input{
      min-height: 15px;
    }
  }
}
</style>
